<script lang="ts" setup>
import { type OtTabType } from '@1trading/design-system';
import { find, propEq } from 'lodash/fp';
import type { PropType } from 'vue';
import { computed } from 'vue';

import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';
import { OrderType } from '@exchange/libs/order/shared-model/src/lib/order-essentials';

import type { OrderTypeOption } from './OrderTypes';

const props = defineProps({
  availableTypes: { type: Array as PropType<Array<OrderTypeOption>>, required: true },
  selectedType: { type: String as PropType<OrderType>, required: true },
  isFutures: { type: Boolean, required: false, default: false },
});
const emit = defineEmits<{
  (e: 'type-selected', value: OrderType): void;
}>();

const { isXS } = useMQBreakpoints();

const activeTypeOption = computed(() => find(propEq('type', props.selectedType), props.availableTypes));

const tabs = computed(() =>
  props.availableTypes.map((typeOption) => ({
    getTitle: () => typeOption.label,
    id: typeOption.type,
    active: props.selectedType === typeOption.type,
  })),
);

const onTypeSelected = (type: OrderType) => {
  emit('type-selected', type);
};

const onSelectValueChange = (value: OrderTypeOption) => {
  onTypeSelected(value.type);
};

const onTabSelected = (tab: OtTabType<string>) => {
  onTypeSelected(tab.id as OrderType);
};
</script>

<template>
  <div class="order-type-chooser">
    <ot-select
      v-if="isXS"
      class="order-type-chooser__select"
      label="label"
      :options="availableTypes"
      :value="activeTypeOption"
      :disabled="availableTypes.length < 2"
      @update:value="onSelectValueChange"
    />
    <ot-tabs
      v-else
      class="order-type-chooser__tabs"
      :tabs="tabs"
      :dense="true"
      @tab-selected="onTabSelected"
    />
  </div>
</template>
